<template>
  <section class="serving-endpoint-section">
    <runai-folding-sub-section v-if="showExpansion" label="Serving endpoint" aid="serving-endpoint-access-btn">
      <serving-endpoint-access
        :model-value="modelValue"
        :title="title"
        :title-tooltip="titleTooltip"
        :show-protocol-and-port="showProtocolAndPort"
        @update:model-value="onModelChanged"
        :protocol-disabled="protocolDisabled"
        :port-disabled="portDisabled"
        :disabled="disabled"
        :disabled-info="disabledInfo"
      />
    </runai-folding-sub-section>
    <serving-endpoint-access
      v-else
      :model-value="modelValue"
      :title="title"
      :title-tooltip="titleTooltip"
      :show-protocol-and-port="showProtocolAndPort"
      @update:model-value="onModelChanged"
      :protocol-disabled="protocolDisabled"
      :port-disabled="portDisabled"
      :disabled="disabled"
      :disabled-info="disabledInfo"
    />
  </section>
</template>

<script lang="ts">
import { defineComponent, type PropType } from "vue";

// cmps
import ServingEndpointAccess from "./serving-endpoint-access.vue";
import { RunaiFoldingSubSection } from "@/components/common/runai-folding-sub-section";

// models
import type { IServingEndpointAccessData } from "./serving-endpoint-access.model";

export enum EServingEndpointSectionEvents {
  UpdateModelValue = "update:model-value",
}

export default defineComponent({
  name: "serving-endpoint-section",
  components: {
    ServingEndpointAccess,
    RunaiFoldingSubSection,
  },
  emits: {
    [EServingEndpointSectionEvents.UpdateModelValue]: (modelValue: IServingEndpointAccessData) => modelValue,
  },
  props: {
    modelValue: {
      type: Object as PropType<IServingEndpointAccessData>,
      required: true,
    },
    title: {
      type: String as PropType<string>,
      required: true,
    },
    titleTooltip: {
      type: String as PropType<string>,
      required: false,
    },
    showExpansion: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    showProtocolAndPort: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    protocolDisabled: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    portDisabled: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    disabled: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    disabledInfo: {
      type: String as PropType<string>,
      required: false,
    },
  },
  methods: {
    onModelChanged(modelValue: IServingEndpointAccessData): void {
      this.$emit(EServingEndpointSectionEvents.UpdateModelValue, modelValue);
    },
  },
});
</script>
<style lang="scss" scoped></style>
